import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export const useSurfUsAnnouncement = () => {
	const { us_announcement } = useModuleData();
	const { viewModule } = useModuleNavigation();

	// 数据
	const usAnnouncementData = computed(() => us_announcement.data?.data || []);

	// 加载数据
	const loadUsAnnouncementData = async (params = {}) => {
		await us_announcement.refresh({
			pageNum: params.pageNum,
			pageStart: params.pageStart,
			typeList: params.typeList || '',
			title: params.title || ''
		});
	};

	const formatForOverview = item => {
		return {
			date: item.date || '',
			value: item.desc || '',
			value2: item.type || ''
		};
	};

	// 预览详情
	const handlePreview = item => {
		viewModule('us_announcement', item);
	};

	// 是否为空
	const isEmpty = computed(() => {
		return us_announcement.empty || !usAnnouncementData.value.length;
	});

	return {
		us_announcement,
		usAnnouncementData,
		loadUsAnnouncementData,
		formatForOverview,
		handlePreview,
		isEmpty
	};
};
